import {DEVELOPMENT, PRODUCTION} from "../constants/environment"
export const selectedEnvironment = PRODUCTION
export const useBackendEmulator = false